import { withText } from './Text';
import { Plain } from './Text.styles';

const PlainText = withText(Plain);

PlainText.displayName = 'PlainText';

export { PlainText };
